import Select from '@components/v2/form/Select/Select';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { GridSizeEnum } from '../../enums/gridSize.enum';
import { getGridSizeLangEnum } from '../../utils/getGridSizeSelectLabel.utils';
import { GridSizeSectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const GridSizeSectionGeneralSettings = ({
  generalSettings,
  handleChangeAndBlur,
}: GridSizeSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  const gridSizeItems = Object.keys(GridSizeEnum).map((size) => {
    const translation = getGridSizeLangEnum(size as GridSizeEnum);
    return {
      value: size,
      label: translate(translation.label),
      description: translate(translation.description),
    };
  });

  return (
    <SettingContainer
      title={translate(LangEnum.GLOBAL_GRID)}
      description={LangEnum.GENERAL_SETTINGS_GRID_SIZE_SETTINGS_DESCRIPTION}
    >
      <Select
        label={translate(LangEnum.GENERAL_SETTINGS_GRID_SIZE_SETTINGS_SELECT_LABEL)}
        name="gridSize"
        value={generalSettings.gridSize ?? ''}
        renderValue={(selected) =>
          gridSizeItems.find((item) => item.value === selected)?.label ?? ''
        }
        onChange={(event) =>
          handleChangeAndBlur({ value: (event.target.value as string) || null, name: 'gridSize' })
        }
      >
        {gridSizeItems.map((item) => (
          <MenuItem
            key={item.value}
            value={item.value}
            sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5 }}
          >
            <Typography variant="body1">{item.label}</Typography>
            <Typography variant="body2" color="textSecondary">
              {item.description}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </SettingContainer>
  );
};

export default GridSizeSectionGeneralSettings;
